import React, { useState, useEffect } from "react";
import "../../Assets/Css/Dashboard.scss";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import Chart from "../../Components/Chart";
import TileWithoutImg from "../../Components/TileWithoutImg";
import TileWithImg from "../../Components/TileWithImg";
import { getDashboardData } from "../../Services/Dashboard/action";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import UserAvatar from "react-user-avatar";

const Dashboard = ({ dashboardData, loading, getDatas }) => {
  const [balance, setBalance] = useState(0);
  const [clients, setClients] = useState(0);
  const [avgIncomeAmount, setAvgIncomeAmount] = useState(0);
  const [avgSpentAmount, setAvgSpentAmount] = useState(0);
  const [avgIncomePercentage, setAvgIncomePercentage] = useState(0);
  const [avgSpentPercentage, setAvgSpentPercentage] = useState(0);
  const [statsData, setStatsData] = useState([]);
  const [shareHoldersData, setShareHoldersData] = useState([]);

  useEffect(() => {
    getDatas();
  }, []);

  useEffect(() => {
    if (dashboardData) {
      setBalance(dashboardData?.balance);
      setClients(dashboardData?.totalClients);
      setAvgIncomeAmount(dashboardData?.monthlyAvgIncome);
      setAvgSpentAmount(dashboardData?.monthlyAvgSpent);
      setStatsData(dashboardData?.statsData);
      setAvgIncomePercentage(dashboardData?.incomeChangePercentage);
      setAvgSpentPercentage(dashboardData?.spentChangePercentage);

      let shData = dashboardData?.shareholdersData?.map((sh) => ({
        name: sh?.name,
        email: sh?.email,
        src: "",
        balance: sh?.balance !== null ? `₹${sh?.balance}` : "₹0",
      }));

      shData = [...(shData || [])]?.sort((a, b) => {
        const balanceA = parseFloat(a.balance.replace("₹", "")) || 0;
        const balanceB = parseFloat(b.balance.replace("₹", "")) || 0;
        return balanceB - balanceA;
      });

      shData?.length &&
        shData?.push({
          name: "Unassigned",
          email: "",
          src: "",
          balance: `₹${dashboardData?.unassignedAmount || 0}`,
        });
      if (shData.length > 0) {
        setShareHoldersData(shData);
      }
    }
  }, [dashboardData]);

  return (
    <Sidebarlayout>
      {loading ? (
        <>
          <Spinner animation="rounded" size="sm" />
          Loading...
        </>
      ) : (
        <div className="main-division">
          <div className="row firstRow">
            <div className="col-lg-4 col-md-6 mb-3">
              <TileWithoutImg
                image="image-b"
                title="Balance"
                stats={`₹${(balance || 0).toFixed(2)}`}
                subtitle="Total Revenue"
              />
            </div>
            <div className="col-lg-3 col-md-6 mb-3">
              <TileWithoutImg
                image="image-c"
                title="Clients"
                stats={clients}
                subtitle="Total no of Client"
              />
            </div>
            <div className="col-lg-5 col-md-12 mb-3">
              <TileWithImg
                avgIncomeAmount={avgIncomeAmount}
                avgIncomePercentage={avgIncomePercentage}
                avgSpentAmount={avgSpentAmount}
                avgSpentPercentage={avgSpentPercentage}
              />
            </div>
          </div>
          <div className="row secRow">
            <div className="col-xl-8 col-lg-7 mb-3">
              <div className="chart">
                <div className="title-part">
                  <p className="card-heading">Statistics</p>
                </div>
                <div className="content-part">
                  <div className="chart-content">
                    <Chart data={statsData} />
                  </div>
                  <div className="chart-label">
                    <div className="label-1">
                      <div className="label-circle-ear"></div>
                      <div className="label-text-ear">Earnings</div>
                    </div>
                    <div className="label-1">
                      <div className="label-circle-exp"></div>
                      <div className="label-text-exp">Expense</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5 mb-3">
              <div className="shareholder-table">
                <div className="table-title">
                  <p className="card-heading">Share Holders</p>
                </div>
                <div className="table-content">
                  <div className="header-line">
                    <h6 className="sh-name">Share Holder</h6>
                    <h6 className="sh-balance">Amount</h6>
                  </div>
                  <div className="sh-container">
                    {shareHoldersData?.length ? (
                      shareHoldersData?.map((sh) => {
                        return (
                          <div className="sh-row">
                            <div className="client">
                              <div className="client-image">
                                <UserAvatar
                                  size="40"
                                  src={sh?.src}
                                  name={sh?.name}
                                />
                              </div>
                              <div className="client-data">
                                <h6 className="highlight-text">
                                  {sh?.name}
                                </h6>
                                <h6 className="small-text">
                                  {sh?.email}
                                </h6>
                              </div>
                            </div>
                            <h6 className="amount">{sh?.balance}</h6>
                          </div>
                        );
                      })
                    ) : (
                      <p>No data to show...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Sidebarlayout>
  );
};
export const mapStateToProps = (state) => {
  return {
    dashboardData: state.dashboardReducer.dashboardData,
    loading: state.dashboardReducer.loading,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getDatas: () => {
      dispatch(getDashboardData());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
